import { useId } from 'react'
import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes } from 'react'
import './pole.css'

interface Wspolne {
  etykieta: string
  podpowiedz?: ReactNode
  blad?: string
}

type PropsPola = Wspolne & InputHTMLAttributes<HTMLInputElement>

export function Pole({ etykieta, podpowiedz, blad, className, ...reszta }: PropsPola) {
  const id = useId()
  const idOpisu = `${id}-opis`
  return (
    <div className="pole">
      <label className="pole__etykieta" htmlFor={id}>
        {etykieta}
      </label>
      <input
        id={id}
        className={['pole__wejscie', blad !== undefined ? 'pole__wejscie--blad' : '', className ?? '']
          .filter(Boolean)
          .join(' ')}
        aria-invalid={blad !== undefined || undefined}
        aria-describedby={blad !== undefined || podpowiedz !== undefined ? idOpisu : undefined}
        {...reszta}
      />
      {blad !== undefined ? (
        <p className="pole__blad" id={idOpisu}>
          {blad}
        </p>
      ) : podpowiedz !== undefined ? (
        <p className="pole__podpowiedz" id={idOpisu}>
          {podpowiedz}
        </p>
      ) : null}
    </div>
  )
}

type PropsWyboru = Wspolne & SelectHTMLAttributes<HTMLSelectElement> & { children: ReactNode }

export function Wybor({ etykieta, podpowiedz, blad, children, ...reszta }: PropsWyboru) {
  const id = useId()
  const idOpisu = `${id}-opis`
  return (
    <div className="pole">
      <label className="pole__etykieta" htmlFor={id}>
        {etykieta}
      </label>
      <select
        id={id}
        className="pole__wejscie pole__wejscie--wybor"
        aria-invalid={blad !== undefined || undefined}
        aria-describedby={blad !== undefined || podpowiedz !== undefined ? idOpisu : undefined}
        {...reszta}
      >
        {children}
      </select>
      {blad !== undefined ? (
        <p className="pole__blad" id={idOpisu}>
          {blad}
        </p>
      ) : podpowiedz !== undefined ? (
        <p className="pole__podpowiedz" id={idOpisu}>
          {podpowiedz}
        </p>
      ) : null}
    </div>
  )
}
